import React from 'react'

import { Navbar, Footer } from '../../../components';
import PremiumArticle from './PremiumArticle';

export default function Premarticle7() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <PremiumArticle article="article7" headerImage="elec.jpg" photographer=" Johannes Plenio" />
        <Footer />
    </div>
  )
}
